import Heading from "app/components/Heading"
import Body from "app/components/Form/Body"
import { ProductOption } from "app/components/ProductOption"
import { StyledGrid } from "app/pages/appFlow/style"
import { BankEnum } from "app/pages/appFlow/types"
import { useAppflow } from "app/hooks/useAppFlow"
import { Controller, useFormContext } from "react-hook-form"
import { FormStateValues } from "state/form/types"
import { PreOwnedFormStateValues } from "state/preownedForm/types"
import { useTranslate } from "hooks/translate"
import { pushCustomTag } from "hooks/useGoogleTagManager"
import { useEffect } from "react"

const Step1: React.FC = () => {
  const { t } = useTranslate()
  const { bank, setBank } = useAppflow()

  const { control } = useFormContext<
    FormStateValues | PreOwnedFormStateValues
  >()

  const handleBankSelection = (selectedBank: BankEnum) => {
    setBank(selectedBank)
  }

  useEffect(() => {
    pushCustomTag({ event: "bank_selected", bank_selected: bank })
  }, [bank])

  return (
    <>
      <Body>
        <Heading>{t("system.bank_select.title")}</Heading>
        <StyledGrid>
          <ProductOption
            title={t("system.bank_select.kbc.title")}
            description={t("system.bank_select.kbc.description")}
            onClick={() => handleBankSelection(BankEnum.KBC)}
            selected={bank === BankEnum.KBC}
          ></ProductOption>
          <ProductOption
            title={t("system.bank_select.cbc.title")}
            description={t("system.bank_select.cbc.description")}
            onClick={() => handleBankSelection(BankEnum.CBC)}
            selected={bank === BankEnum.CBC}
          ></ProductOption>
          <Controller
            defaultValue={bank}
            rules={{ required: true }}
            name="bank"
            render={() => <input hidden value={bank} onChange={() => {}} />}
            control={control}
          />
        </StyledGrid>
      </Body>
    </>
  )
}

export default Step1
